const RagChatView = ({ response, data, prompts, bottomRef }) => {
  return (
    <div className="h-[100%] w-full px-2 overflow-scroll no-scrollbar text-base leading-7 tracking-wide text-white/50 ">
      {data?.length > 0 &&
        data?.map((res, index) => (
          <div key={index} id={`${index}_id`}>
            <div className="w-full flex py-5">
              <p className="bg-white/5 w-fit px-2 py-1 rounded-lg rounded-br-none items-end ml-auto">
                {prompts?.[index]}
              </p>
            </div>
            <div className="py-1">
              {typeof res === "string" &&
                res.split("\n\n").map((r, idx) => (
                  <p key={`0_${idx}`} className="my-3 sm:w-[90%] lg:w-[80%]">
                    {r.includes('"error":') ? (
                      <span className="bg-red-900/20 px-2 py-1 rounded-sm">
                        {r.split('"error":')[1].replace(/["}]/g, "")}
                      </span>
                    ) : (
                      r
                    )}
                  </p>
                ))}
            </div>
          </div>
        ))}
      {response && !data.includes(response) && (
        <div id="0_id">
          <div className="w-full flex py-5">
            <p className="bg-white/5 w-fit px-2 py-1 rounded-lg rounded-br-none items-end ml-auto">
              {prompts?.[prompts?.length - 1]}
            </p>
          </div>
          {response?.split("\n\n").map((r, idx) => (
            <p key={`#-${idx}`} className="my-3 w-full sm:w-[90%] lg:w-[80%]">
              {r}
            </p>
          ))}
        </div>
      )}
      <div ref={bottomRef} />
    </div>
  );
};

export default RagChatView;
